import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-media-gallery',
  templateUrl: './media-gallery.component.html',
  styleUrls: ['./media-gallery.component.scss']
})
export class MediaGalleryComponent implements OnChanges {
@Input() mediaData;

mediaObj=[];
mediaModal=false;
openMediaIndex=0;
  constructor() {
    // No Code
  }

  ngOnChanges(): void {
    // console.log(this.mediaData);
    this.mediaObj = [];
    for (let i = 0; i < this.mediaData.length; i++) {
      const  t = {
        media_id: this.mediaData[i].id,
        media_name: this.mediaData[i].caption,
        media_thumbnail: this.mediaData[i].preview_url,
        media_type: this.mediaData[i].file_type,
        media_url: this.mediaData[i].file_url
      };
      this.mediaObj.push(t);
    }
  }

  setResetMediaModal(): void {
    this.mediaModal = false;
  }

  showMediaModal(index): void {
    this.openMediaIndex = index;
   // console.log(this.mediaObj);
    this.mediaModal = true;
  }
}
